// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/sections/Contact.css */
.contact {
  padding: 100px 0;
  background: linear-gradient(180deg, var(--dark-secondary) 0%, var(--dark-bg) 100%);
  position: relative;
  overflow: hidden;
}

.contact-content {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 60px;
  margin-top: 60px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.info-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 25px;
  background: rgba(26, 26, 26, 0.8);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  text-decoration: none;
  color: var(--text-primary);
  transition: all 0.3s ease;
  cursor: pointer;
}

.info-card:hover {
  transform: translateX(10px);
  border-color: var(--primary-color);
  box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);
}

.info-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-primary);
  border-radius: 15px;
  flex-shrink: 0;
}

.info-icon svg {
  color: var(--dark-bg);
}

.info-details h4 {
  font-size: 1.1rem;
  margin-bottom: 5px;
  color: var(--text-primary);
}

.info-details p {
  font-size: 0.95rem;
  color: var(--text-secondary);
}

.contact-form {
  background: rgba(26, 26, 26, 0.5);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 40px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 1rem;
  font-family: inherit;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 20px rgba(0, 242, 254, 0.2);
}

.form-input::placeholder {
  color: var(--text-secondary);
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
}

.form-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin-top: 30px;
  padding: 15px 30px;
  font-size: 1.1rem;
}

.form-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.form-message {
  margin-top: 20px;
  padding: 15px 20px;
  border-radius: 10px;
  text-align: center;
  font-weight: 500;
}

.form-message.success {
  background: rgba(39, 174, 96, 0.2);
  border: 1px solid rgba(39, 174, 96, 0.5);
  color: #27ae60;
}

.form-message.error {
  background: rgba(231, 76, 60, 0.2);
  border: 1px solid rgba(231, 76, 60, 0.5);
  color: #e74c3c;
}

.contact-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.decoration-circle {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, var(--primary-color) 0%, transparent 70%);
  filter: blur(100px);
}

.circle-1 {
  width: 400px;
  height: 400px;
  top: -200px;
  right: -200px;
}

.circle-2 {
  width: 600px;
  height: 600px;
  bottom: -300px;
  left: -300px;
  background: radial-gradient(circle, var(--accent-color) 0%, transparent 70%);
}

/* Responsive */
@media (max-width: 968px) {
  .contact-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .contact-info {
    order: 2;
  }
  
  .contact-form {
    order: 1;
  }
}

@media (max-width: 640px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .contact-form {
    padding: 30px 20px;
  }
  
  .info-card {
    padding: 20px;
  }
  
  .decoration-circle {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sections/Contact.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,gBAAgB;EAChB,kFAAkF;EAClF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6EAA6E;EAC7E,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,YAAY;EACZ,4EAA4E;AAC9E;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* src/components/sections/Contact.css */\n.contact {\n  padding: 100px 0;\n  background: linear-gradient(180deg, var(--dark-secondary) 0%, var(--dark-bg) 100%);\n  position: relative;\n  overflow: hidden;\n}\n\n.contact-content {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 60px;\n  margin-top: 60px;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.info-card {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 25px;\n  background: rgba(26, 26, 26, 0.8);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  text-decoration: none;\n  color: var(--text-primary);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.info-card:hover {\n  transform: translateX(10px);\n  border-color: var(--primary-color);\n  box-shadow: 0 10px 30px rgba(0, 242, 254, 0.2);\n}\n\n.info-icon {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--gradient-primary);\n  border-radius: 15px;\n  flex-shrink: 0;\n}\n\n.info-icon svg {\n  color: var(--dark-bg);\n}\n\n.info-details h4 {\n  font-size: 1.1rem;\n  margin-bottom: 5px;\n  color: var(--text-primary);\n}\n\n.info-details p {\n  font-size: 0.95rem;\n  color: var(--text-secondary);\n}\n\n.contact-form {\n  background: rgba(26, 26, 26, 0.5);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 40px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  position: relative;\n}\n\n.form-input {\n  width: 100%;\n  padding: 15px 20px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: var(--text-primary);\n  font-size: 1rem;\n  font-family: inherit;\n  transition: all 0.3s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 20px rgba(0, 242, 254, 0.2);\n}\n\n.form-input::placeholder {\n  color: var(--text-secondary);\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.form-submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  margin-top: 30px;\n  padding: 15px 30px;\n  font-size: 1.1rem;\n}\n\n.form-submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid transparent;\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.form-message {\n  margin-top: 20px;\n  padding: 15px 20px;\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.form-message.success {\n  background: rgba(39, 174, 96, 0.2);\n  border: 1px solid rgba(39, 174, 96, 0.5);\n  color: #27ae60;\n}\n\n.form-message.error {\n  background: rgba(231, 76, 60, 0.2);\n  border: 1px solid rgba(231, 76, 60, 0.5);\n  color: #e74c3c;\n}\n\n.contact-decoration {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.decoration-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: radial-gradient(circle, var(--primary-color) 0%, transparent 70%);\n  filter: blur(100px);\n}\n\n.circle-1 {\n  width: 400px;\n  height: 400px;\n  top: -200px;\n  right: -200px;\n}\n\n.circle-2 {\n  width: 600px;\n  height: 600px;\n  bottom: -300px;\n  left: -300px;\n  background: radial-gradient(circle, var(--accent-color) 0%, transparent 70%);\n}\n\n/* Responsive */\n@media (max-width: 968px) {\n  .contact-content {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n  \n  .contact-info {\n    order: 2;\n  }\n  \n  .contact-form {\n    order: 1;\n  }\n}\n\n@media (max-width: 640px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .contact-form {\n    padding: 30px 20px;\n  }\n  \n  .info-card {\n    padding: 20px;\n  }\n  \n  .decoration-circle {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
